// @ts-nocheck
import dom from "../../dom2.js";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const dontTreeShakeDom = dom;
import {TOPIC_COLORS} from "../../../../main/constants/colors.js";

const getColor = props => {
	const defaultColors = TOPIC_COLORS.default.topics;
	let color = "000000", minCt = 999;

	for (const defaultColor of defaultColors) {
		let ct = 0;

		for (const topic of props.topics) {
			if (topic.color === defaultColor)
				ct++;
		}

		if (ct < minCt) {
			minCt = ct;
			color = defaultColor;
		}
	}

	return color;
};

const TopicCreate = props => {
	var color = getColor(props);
	var styles = {backgroundColor: "#" + color};

	return (
		<div className="new-topic js-topic-create">
			<button type="button" className="new-btn-topic" style={styles}></button>
			<input type="hidden" name="color" value={color} />
			<input
				autoComplete="off"
				className="new-topic-name js-new-topic-name"
				name="label"
				onBlur={props.onBlurOnTopicLabel}
				onFocus={props.onFocusOnTopicLabel}
				onKeyUp={props.onKeyupOnTopicLabel}
				placeholder="New Topic"
				type="text"
			/>
			<button
				className="btn-save-topic js-btn-save-topic"
				onClick={props.onClickSaveTopic}
				type="button"
			>Save</button>
		</div>
	);
};

export default TopicCreate;
